import { DRIVE_POS_ADOPTION_240517 } from "@faire/web-api/indigofair/settings/DRIVE_POS_ADOPTION_240517";

import {
  getSettingValueWithoutAssignment,
  getSettingValueAndAssign,
} from "@faire/retailer/settings/__internal__/getSetting";

export const getSettingDrivePosAdoption = (): boolean =>
  getSettingValueWithoutAssignment(DRIVE_POS_ADOPTION_240517, false);

export const getSettingDrivePosAdoptionAndAssign = (): boolean =>
  getSettingValueAndAssign(DRIVE_POS_ADOPTION_240517, false);
